export default "__VITE_ASSET__BjDdsBpa__"